/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable consistent-return */
import { Button, Grid, IconButton, } from '@material-ui/core';
import {
  getSchoolFormations,
  postCreateClasse,
  postUpdateClasse,
} from '@webapps/business';
import {
  Modal,
  FormikAutocomplete,
  FormikDatePicker,
  FormikTextField,
  useAuth,
  useMutation,
  useQuery,
  useToast,
  useRouter,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Row from 'components/Form/Row';
import { format } from 'date-fns';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import * as yup from 'yup';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import Information from 'components/Icons/Information';
import { ROUTES_PATH } from 'config/constants';

const matiereSchema = yup.object().shape({
  label: yup.string().required('Requis'),
  training: yup.string().required('Requis'),
});

const NewClasses = ({ close, data, refetch, handleOpenSetPlanning, handleSetIdClassCreated }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser } = useAuth();

  const {
    isLoading,
    isSuccess,
    mutateAsync: mutateClasse,
  } = useMutation(postCreateClasse);

  const {
    isLoading: isLoadingUpdateClasse,
    isSuccess: isSuccessUpdateClasse,
    mutateAsync: mutateUpdateClasse,
  } = useMutation(postUpdateClasse);

  const [page, setPage] = useState(1);

  const {
    status: load,
    data: { content: formations = [], totalElements } = {},
    isFetching,
  } = useQuery(getSchoolFormations, {
    key: ['formations', page],
    variables: { id: idUser, page: page - 1, size: 20 },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const { addToast } = useToast();
  const [openGenerateCode, setOpenGenerateCode] = useState(false);
  const [generatedCode, setGeneratedCode] = useState("");

  const copyToClipboard = () => {
    navigator.clipboard.writeText(generatedCode);
    addToast({
      status: 'success',
      message: 'Code copié dans le presse-papier',
    });
  };

  useEffect(() => {
    if (isSuccess) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
      setOpenGenerateCode(true);
      refetch();
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isSuccessUpdateClasse) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
      close();
      refetch();
    }
  }, [isSuccessUpdateClasse]);

  const formik = useFormik({
    initialValues: {
      label: data?.label || '',
      training: data?.training || '',
      endDate: data?.endDate || '',
      startDate: data?.startDate || '',
    },
    validationSchema: matiereSchema,
    onSubmit: async ({ endDate, startDate, ...values }) => {
      if (data) {
        await mutateUpdateClasse({
          data: {
            endDate: format(new Date(endDate), "yyyy-MM-dd'T'HH:mm:ss"),
            startDate: format(new Date(startDate), "yyyy-MM-dd'T'HH:mm:ss"),
            ...values,
          },
          id: data?.id,
        });
      } else {
        const response = await mutateClasse({
          data: {
            endDate: format(new Date(endDate), "yyyy-MM-dd'T'HH:mm:ss"),
            startDate: format(new Date(startDate), "yyyy-MM-dd'T'HH:mm:ss"),
            ...values,
          },
          id: idUser,
        });
        setGeneratedCode(response.data.code)

        handleSetIdClassCreated(response.data?.classroom?.id)
      }
    },
  });

  const handleCloseGenerateCode = () => {
    setOpenGenerateCode(false);
    close();


    // after 1 second setOpenSetPlanning to true
    setTimeout(() => {

      handleOpenSetPlanning()
    }, 1000);
  }

  return (
    <div>
      <Row>
        <Grid container spacing={2}>
          {/* <Grid className={css({ marginTop: spacing(2) })} item xs={12}>
            <FormikAutocomplete
              defaultValue=""
              formik={formik}
              fullWidth
              getOptionLabel={(option) => option.label || ''}
              getOptionSelected={(option, value) => value.id === option.id}
              label="Niveau de diplome"
              name="degreeLevel"
              options={degreeLevels}
              pathValue="id"
              value={
                degreeLevels.find(
                  ({ id }) => id === formik.values.degreeLevel
                ) || null
              }
            />
          </Grid> */}
          <Grid item xs={12} className={cx(global.subTitle, classes.subTitle)}>
            <div className={css({ display: 'flex', flexDirection: 'row' })}>
              <span>
                <Information className={cx(global.infoIcon, css({ color: '#0060F9' }))} />
              </span>
              <FormattedMessage id="school.createClasse.subTitle" />
            </div>
          </Grid>
          <Grid item xs={12}>
            <FormikAutocomplete
              defaultValue=""
              formik={formik}
              fullWidth
              getOptionLabel={(option) => option.label || ''}
              getOptionSelected={(option, value) => value.id === option.id}
              label="Formation"
              name="training"
              onChange={(e, value) => {
                formik.setFieldValue('training', value?.id);
                formik.setFieldValue('startDate', value?.openingDate);
                formik.setFieldValue('endDate', value?.closingDate || '');
              }}
              options={formations}
              variant='filled'
              pathValue="id"
              borderRadius={6}
              value={
                formations.find(({ id }) => id === formik.values.training) ||
                null
              }
            />
          </Grid>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              fullWidth
              variant='filled'
              label="Nom de la classe"
              name="label"
              borderRadius={6}
              className={css({ borderRadius: '6px !important' })}
            />
          </Grid>
          {formations.find((formation) => formation?.id === formik.values.training && !formation?.closingDate ) && (
            <Grid item xs={12}>
              <FormikDatePicker
                formik={formik}
                fullWidth
                variant='filled'
                label="Fin de la formation"
                name="endDate"
                borderRadius={6}
              />
            </Grid>
          )}
        </Grid>
      </Row>
      <Row>
        <Grid container spacing={2}>
          <Grid className={css({ textAlign: 'center' })} item xs>
            <Button
              className={css({ borderRadius: '6px' })}
              color="primary"
              disabled={isLoading || isLoadingUpdateClasse}
              onClick={formik.handleSubmit}
              variant="contained"
            >
              <FormattedMessage id="vitrine.btnCreate" />
            </Button>
          </Grid>
        </Grid>
      </Row>
      <Modal
        onCancel={() => handleCloseGenerateCode()}
        open={openGenerateCode}
        title="Votre code d’invitation :"
        withStep={false}
      >
        <div className={classes.copyToClipboardContainer}>
          <div className={cx(global.subTitle, classes.subTitle)}>Appuyez sur le bouton pour copier le code</div>
          <div className={cx(global.subTitle, classes.subTitle)}>(Votre code expire dans 31 jours)</div>
          <IconButton className={classes.copyToClipboard} onClick={copyToClipboard} color="primary">
            <FileCopyIcon className={classes.copyToClipboardIcon} /> {generatedCode}
          </IconButton>
        </div>
      </Modal>


    </div>
  );
};

NewClasses.propTypes = {
  refetch: PropTypes.func,
  close: PropTypes.func,
  data: PropTypes.object,
};

const styles = ({ spacing }) => ({
  copyToClipboard: {
    background: '#0060F9',
    color: 'white',
    borderRadius: 10,
    padding: spacing(1, 2, 1, 2),
    marginTop: spacing(2),
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontWeight: 600,
    '&:hover': {
      background: '#0060F9',
      color: 'white',
    },
  },
  copyToClipboardContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  copyToClipboardIcon: {
    marginRight: spacing(1),
    '@media only screen and (max-width:1920px)': { fontSize: '15.0px' },
    '@media only screen and (max-width:1600px)': { fontSize: '15px' },
  },
  subTitle: {
    fontWeight: 400,
    width: '100%',
  },
});

export default NewClasses;
